import { render, staticRenderFns } from "./StampaDdt.vue?vue&type=template&id=54481a4c&scoped=true"
import script from "./StampaDdt.vue?vue&type=script&lang=ts"
export * from "./StampaDdt.vue?vue&type=script&lang=ts"
import style0 from "./StampaDdt.vue?vue&type=style&index=0&id=54481a4c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54481a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54481a4c')) {
      api.createRecord('54481a4c', component.options)
    } else {
      api.reload('54481a4c', component.options)
    }
    module.hot.accept("./StampaDdt.vue?vue&type=template&id=54481a4c&scoped=true", function () {
      api.rerender('54481a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/StampaDdt.vue"
export default component.exports